// Date-based option prices (early bird / late fee). Dates are "YYYY-MM-DD" in IST, matching the backend.
export const todayIst = (now = new Date()) => now.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });

const validTiers = (option) => (option?.priceSchedule || [])
  .filter((tier) => tier && /^\d{4}-\d{2}-\d{2}$/.test(tier.fromDate || '') && tier.price != null && tier.price !== '');

/** Price that applies today: base price until the first tier starts, then the latest tier reached. */
export function optionPrice(option, now = new Date()) {
  const today = todayIst(now);
  const reached = validTiers(option).filter((tier) => tier.fromDate <= today)
    .sort((a, b) => a.fromDate.localeCompare(b.fromDate));
  const price = reached.length ? reached[reached.length - 1].price : option?.price;
  return Number(price) || 0;
}

export const OPTION_CURRENCIES = ['INR', 'USD', 'EUR', 'GBP', 'AED', 'SGD'];

/** Blank option currency is INR, matching the form builder default. */
export function optionCurrency(option) {
  return String(option?.currency || 'INR').toUpperCase();
}

/** Add one selected option's current price into a { CURRENCY: amount } map. */
export function addPricedOption(totals, option) {
  const amount = optionPrice(option);
  if (!amount) return totals;
  const currency = optionCurrency(option);
  return { ...totals, [currency]: (totals[currency] || 0) + amount };
}

/** Amount in the currency the payment is taken in. Other currencies stay in the map for display. */
export function chargeable(totals, currency = 'INR') {
  return totals?.[String(currency || 'INR').toUpperCase()] || 0;
}

/** Next scheduled price change after today, or null. */
export function nextPriceChange(option, now = new Date()) {
  const today = todayIst(now);
  const upcoming = validTiers(option).filter((tier) => tier.fromDate > today)
    .sort((a, b) => a.fromDate.localeCompare(b.fromDate));
  return upcoming.length ? { fromDate: upcoming[0].fromDate, price: Number(upcoming[0].price) || 0 } : null;
}
